/* ==========================================================================
   VI Grapes & Styles — page decorator for "Druvor & Vinstilar"
   --------------------------------------------------------------------------
   This is a thin enhancement layer on top of the shared engine
   (vi-knowledge-hub.js). It does NOT re-implement search/filter/rendering;
   it only listens to the engine's `vi-knowledge:rendered` event and colour-
   codes each card by grape/style family for the accent styling defined in
   vi-grapes-styles.css. Loading order in the section: engine first, then this.

   No external libraries. No globals beyond a single namespaced guard.
   ========================================================================== */
(function () {
  'use strict';

  // Maps a normalised category to a colour family used by vi-grapes-styles.css.
  var FAMILY = {
    'red-grape': 'red',
    'white-grape': 'white',
    'grape': 'red',
    'sparkling': 'sparkling',
    'dessert': 'dessert',
    'fortified': 'fortified',
    'style': 'style'
  };

  function decorate(root) {
    if (!root || !root.classList || !root.classList.contains('vi-grapes')) return;
    var cards = root.querySelectorAll('.vi-knowledge-card[data-category]');
    for (var i = 0; i < cards.length; i++) {
      var cat = cards[i].getAttribute('data-category') || '';
      var family = FAMILY[cat];
      if (family) cards[i].setAttribute('data-vi-grape-color', family);
    }
  }

  // The engine re-renders on search/filter/sort and fires this each time.
  document.addEventListener('vi-knowledge:rendered', function (ev) {
    if (ev && ev.target) decorate(ev.target);
  });

  // Decorate anything already on the page (in case render fired before this
  // listener attached, e.g. cached responses).
  function initial() {
    var roots = document.querySelectorAll('.vi-grapes[data-vi-knowledge]');
    for (var i = 0; i < roots.length; i++) decorate(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initial);
  } else {
    initial();
  }
})();
